import { loadCollectionItems } from '../../pluginComponentApi';

export const PermissionButton = (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="webconnect-shield-lock"></i><div>${label}</div>`,
    category: category,
    content: `
    <form class="form dc-form-default dc-form-bordered" data-gjs-type="${type}" data-gjs="${type}">
      <div class="col-12 col-md-12">
        <h4 class="title">Permission Form</h4>
      </div>
      <div class="form-container row mx-auto"></div>
    </form>
    `,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, version, events, multiTenantPlugin, collections } = config;
  let tenantCollection,
    userSettingCollection = '';
  if (
    multiTenantPlugin &&
    multiTenantPlugin.setting &&
    multiTenantPlugin.setting.multiTenantCollection
  ) {
    const multiTenantCollection = multiTenantPlugin.setting.multiTenantCollection;
    const userSettingsCollection = multiTenantPlugin.setting.userSettingsCollection;
    tenantCollection = collections.find((coll) => coll.uuid === multiTenantCollection);
    userSettingCollection = collections.find((coll) => coll.uuid === userSettingsCollection);
  }
  let eventOptions = events.map((event) => ({
    label: event.eventTitle,
    value: `${event.eventName}(event)`,
  }));
  eventOptions = [{ label: '- Select Event - ', value: '' }, ...eventOptions];
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: `<svg height="10" viewBox="0 0 50 45" xmlns="http://www.w3.org/2000/svg">
          <g fill="#c3cfe9" fill-rule="evenodd">
          <path d="M102.473 32.722h4.489V14.934h-4.489zM124.39 18.268a7.376 7.376 0 00-2.14-2.053c-1.355-.854-3.204-1.28-5.545-1.28h-5.914v17.787h6.918c2.5 0 4.506-.817 6.02-2.453 1.514-1.635 2.27-3.805 2.27-6.508 0-2.15-.537-3.981-1.61-5.493m-7.182 10.427h-1.927v-9.734h1.954c1.373 0 2.428.43 3.168 1.287.74.857 1.11 2.073 1.11 3.647 0 3.2-1.435 4.8-4.305 4.8M18.637 0L4.09 3.81.081 18.439l5.014 5.148L0 28.65l3.773 14.693 14.484 4.047 5.096-5.064 5.014 5.147 14.547-3.81 4.008-14.63-5.013-5.146 5.095-5.063L43.231 4.13 28.745.083l-5.094 5.063zM9.71 6.624l7.663-2.008 3.351 3.44-4.887 4.856zm16.822 1.478l3.405-3.383 7.63 2.132-6.227 6.187zM4.672 17.238l2.111-7.705 6.125 6.288-4.886 4.856zm29.547-1.243l6.227-6.189 1.986 7.74-3.404 3.384zm-15.502-.127l4.887-4.856 4.807 4.936-4.886 4.856zm-7.814 7.765l4.886-4.856 4.81 4.936-4.888 4.856zm15.503.127l4.886-4.856L36.1 23.84l-4.887 4.856zM4.57 29.927l3.406-3.385 4.807 4.937-6.225 6.186zm14.021 1.598l4.887-4.856 4.808 4.936-4.886 4.856zm15.502.128l4.887-4.856 3.351 3.439-2.11 7.705zm-24.656 8.97l6.226-6.189 4.81 4.936-3.406 3.385zm16.843-1.206l4.886-4.856 6.126 6.289-7.662 2.007z"></path></g></svg>`,
          projectId: projectId,
          traits: [
            {
              type: 'checkbox',
              name: 'pageCollection',
              label: 'User Page Collection',
              value: false,
              changeProp: 1,
            },
            {
              type: 'select',
              name: 'onsubmit',
              label: 'Event',
              options: eventOptions,
              changeProp: 1,
            },
          ],
          script: function () {
            const projectId = '{[ projectId ]}';
            console.log('projectId', projectId);
            if (typeof createFormForPermission !== 'undefined') {
              createFormForPermission(projectId, this);
            }
          },
        },
        async init() {
          const permissions = this.get('permissions');
          const onSubmit = this.get('onsubmit');
          const permissionItems = await loadCollectionItems(projectId, version, 'permission');
          console.log('\n permissionItems :>> ', permissionItems);

          let options = [];
          if (!permissionItems || permissionItems.length === 0) {
            options = [{ label: '- Select Permissions - ', value: '' }];
          } else {
            const permissionOptions = permissionItems.map((permission) => ({
              label: permission.name,
              value: `${permission.value}`,
            }));
            options = [{ label: '- Select Permissions - ', value: '' }, ...permissionOptions];
          }
          const allTraits = this.get('traits');
          let traitsSize = allTraits.length;
          let attributes = this.getAttributes();

          const permissionKeys = Object.keys(attributes).filter((attr) =>
            attr.startsWith('permission-'),
          );

          if (permissionKeys && permissionKeys.length > 0) {
            permissionKeys.map((perName, index) => {
              this.addTrait(
                {
                  name: perName,
                  label: `Permission #${index}`,
                  options,
                  type: 'permission-trait',
                },
                { at: traitsSize },
              );
              traitsSize++;
            });
          } else {
            this.addTrait(
              {
                name: `permission-0`,
                label: 'Permission #0',
                options,
                type: 'permission-trait',
              },
              { at: traitsSize },
            );
          }
          this.on('change:onsubmit', this.handleEventChange);
          this.on('change:pageCollection', this.handlePageCollChange);
        },
        handleEventChange() {
          let eventName = this.get('onsubmit');
          let eventNameBackup = this.get('onsubmit');
          eventName = eventName.replace('(event)', '');
          const selEvent = events.find((event) => event.eventName === eventName);
          if (selEvent) {
            let { actions } = selEvent;
            actions = actions[0];
            const attrs = this.getAttributes();
            if (actions.name === 'changePermissionInTenant') {
              attrs['load-permission-from'] = 'tenant';
            } else if (actions.name === 'changePermissionInUser') {
              attrs['load-permission-from'] = 'user';
            } else if (actions.name === 'changePermissionInUserSettings') {
              attrs['load-permission-from'] = 'user-settings';
            } else {
              attrs['load-permission-from'] = '';
            }
            attrs['onsubmit'] = `return ${eventNameBackup}`;
            this.setAttributes(attrs);
          }
        },
        handlePageCollChange() {
          let pageCollection = this.get('pageCollection');
          const attrs = this.getAttributes();
          attrs['page-collection'] = pageCollection ? 'true' : 'false';
          attrs['tenant-collection'] = tenantCollection ? tenantCollection.collectionName : '';
          attrs['user-setting-collection'] = userSettingCollection
            ? userSettingCollection.collectionName
            : '';
          this.setAttributes(attrs);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {},
    }),
  });
};
